import Task1 from 'models/task1';
import styled, { css } from 'styled-components';

import { StyledAvatar } from './avatars';

const EmployeeOwnerAvatar = styled(StyledAvatar)`
  ${({ ownerType, theme }) => css`
    border: 2px solid ${ownerType === Task1.EMPLOYEE_TYPES.owner ? theme.palette.green.main : 'transparent'};
    background-color: ${ownerType === Task1.EMPLOYEE_TYPES.owner ? theme.palette.green.main : 'transparent'};
  `}
`;

export default EmployeeOwnerAvatar;
